/** The route of this UI GitHub's install returns to, through Kinotic, to finish linking the workspace. */
export const GITHUB_CALLBACK_PATH = '/github/callback'
